import { Component, OnInit } from '@angular/core';
import { NbSearchService } from '@nebular/theme';

@Component({
  selector: 'kw-tool-nav',
  templateUrl: './tool-nav.component.html',
  styleUrls: ['./tool-nav.component.scss']
})
export class ToolNavComponent implements OnInit {
  
  constructor(private searchService: NbSearchService) { }

  ngOnInit(): void {
  }

  activateSearch(){
    console.log("Search activated");
    this.searchService.activateSearch("rotate-layout");
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    
  }

 

}
